import { gql } from "@apollo/client";
import { RHTVChannelFragment } from "@/fragments/RockHallTv";

export const ChannelPreview = gql`
  ${RHTVChannelFragment}
  query RHTVChannelPreview($channelId: ID!) {
    channel: rhRhtvChannel(id: $channelId) {
      slug
    }
    preview: rhRhtvChannel(id: $channelId, asPreview: true) {
      ...RhtvChannel
    }
  }
`;
